module.exports = __webpack_public_path__ + "7c8416eba62e1731892c3b0d7c983dc8.MP3";